export default {
      id: "photo-right-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite-46b249.svg#photo-right-usage",
      toString: function () {
        return this.url;
      }
    }